import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {CandidateProfileComponent} from "./candidate-profile/candidate-profile.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CandidateProfileComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {

}
